class GitLabClient {
  constructor(accessToken = '', instanceUrl = 'https://gitlab.com') {
    this.accessToken = accessToken;
    this.baseUrl = `${instanceUrl.replace(/\/$/, '')}/api/v4`;
  }

  getHeaders() {
    const headers = { 'Content-Type': 'application/json' };
    if (this.accessToken) {
      headers['PRIVATE-TOKEN'] = this.accessToken;
    }
    return headers;
  }

  _encodeProjectPath(ownerRepo) {
    // ownerRepo is like '/group/repo' or '/group/subgroup/repo'
    return encodeURIComponent(ownerRepo.replace(/^\//, ''));
  }

  async getBranches(ownerRepo) {
    const id = this._encodeProjectPath(ownerRepo);
    const response = await fetch(
      `${this.baseUrl}/projects/${id}/repository/branches?per_page=100`,
      { headers: this.getHeaders() }
    );
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP ${response.status}`);
    }

    return data.map(b => b.name);
  }

  async getFileTree(ownerRepo, branch) {
    const id = this._encodeProjectPath(ownerRepo);
    let allFiles = [];
    let page = 1;

    while (true) {
      const response = await fetch(
        `${this.baseUrl}/projects/${id}/repository/tree?recursive=true&ref=${encodeURIComponent(branch)}&per_page=100&page=${page}`,
        { headers: this.getHeaders() }
      );
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `HTTP ${response.status}`);
      }

      allFiles = [...allFiles, ...data];

      const nextPage = response.headers.get('X-Next-Page');
      if (!nextPage) break;
      page = parseInt(nextPage, 10);
    }

    return allFiles;
  }

  async getFileContent(ownerRepo, filePath, branch) {
    const id = this._encodeProjectPath(ownerRepo);
    const encodedFilePath = encodeURIComponent(filePath);
    const response = await fetch(
      `${this.baseUrl}/projects/${id}/repository/files/${encodedFilePath}?ref=${encodeURIComponent(branch)}`,
      { headers: this.getHeaders() }
    );
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP ${response.status}`);
    }

    return data.content; // base64 encoded, same as GitHub
  }
}

export default GitLabClient;
